<template>
  <TextField
    type="tel"
    inputmode="numeric"
    ref="phoneField"
    :icon="PhoneIcon"
    name="phone"
    :autocomplete="autocomplete"
    placeholder="Phone"
    v-bind="$props"
  />
</template>

<script>
import PhoneIcon from '@tagvenue/icons/24/line/communication/phone.svg';
import { markRaw } from 'vue';

import inputHandlers from '@/services/inputHandlers';

import TextField from './TextField.vue';

export default {
  components: {
    TextField,
  },
  props: {
    autocomplete: {
      type: String,
      default: 'tel',
    },
  },
  data() {
    return {
      PhoneIcon: markRaw(PhoneIcon),
    };
  },
  mounted() {
    inputHandlers.phone(this.$refs.phoneField.$el);
  },
  beforeUnmount() {
    inputHandlers.removePhone(this.$refs.phoneField.$el);
  },
};
</script>
